import { useRef } from "react";

// Props for a modal's backdrop element: closes only when a click both starts
// and ends on the backdrop itself, so a text selection dragged out of the
// dialog (or a click inside a nested modal) never dismisses it.
export function useBackdropClose(onClose, enabled = true) {
  const downOnBackdrop = useRef(false);
  return {
    onMouseDown: (e) => {
      downOnBackdrop.current = e.target === e.currentTarget;
    },
    onClick: (e) => {
      const hit = downOnBackdrop.current && e.target === e.currentTarget;
      downOnBackdrop.current = false;
      if (hit && enabled && onClose) onClose();
    },
  };
}
